export const YamlPreviewApiAdapter = (client: any) => {
  return {
    getYaml: (yamlLink: string, token: string) =>
      client.get(`/v1/${yamlLink}`, {
        headers: {
          Authorization: token,
        },
      }),
  };
};
